var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import * as React from "react";
const SvgRefresh = (props) => /* @__PURE__ */ React.createElement("svg", __spreadValues({ width: 16, height: 16, fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props), /* @__PURE__ */ React.createElement("path", { d: "M3.642 2.955a6.667 6.667 0 0 1 9.818 8.872L11.332 8h2a5.333 5.333 0 0 0-9.026-3.848l-.665-1.197Zm8.716 10.09A6.667 6.667 0 0 1 2.54 4.173L4.667 8h-2a5.333 5.333 0 0 0 9.026 3.848l.665 1.197Z", fill: "currentColor" }));
export { SvgRefresh as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTMuNjQyIDIuOTU1YTYuNjY3IDYuNjY3IDAgMCAxIDkuODE4IDguODcyTDExLjMzMiA4aDJhNS4zMzMgNS4zMzMgMCAwIDAtOS4wMjYtMy44NDhsLS42NjUtMS4xOTdabTguNzE2IDEwLjA5QTYuNjY3IDYuNjY3IDAgMCAxIDIuNTQgNC4xNzNMNC42NjcgOGgtMmE1LjMzMyA1LjMzMyAwIDAgMCA5LjAyNiAzLjg0OGwuNjY1IDEuMTk3WiIgZmlsbD0iY3VycmVudENvbG9yIi8+PC9zdmc+";
